/**
 * Local storage key rules for new entries:
 * 1) Add every new key to this file.
 * 2) Use format: wf:<feature>:<purpose>
 * 3) Use kebab-case for each segment.
 * 4) If value shape can change, append a version segment: :v1, :v2, ...
 *
 * Examples:
 * - wf:search:selected-view-mode
 * - wf:search:selected-figure-ids:v1
 */

export const HIDE_MODALS_KEY = "hide_modals";
export const COPY_ISIN_MODAL = "COPY_ISIN_MODAL";

export const BENCHMARKS = "benchmarks";

export const SELECTED_WIKIFOLIO_WATCHLIST_FIGURE_IDS = "wf:watchlist:selected-figure-ids";

export const SELECTED_EXTENDED_SEARCH_VIEW_MODE = "wf:search:selected-view-mode";
export const ARTICLE_REACTIONS_SHOWN_KEY = "article_reactions_shown";

export const SMARTUP_MODAL_SHOWN_DATE = "smartup_modal_shown_date";
export const SMARTUP_MODAL_DONT_SHOW = "smartup_modal_dont_show";

export const AUDIO_PLAYER_ACTIVE_TAB_STORAGE_KEY = "wf:audio-player:active-tab";
